import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizenGetAllFeedbackCategories} from './citizen-get-all-feedback-categories.model';

export const loadCitizenGetAllFeedbackCategoriess = createAction(
  '[CitizenGetAllFeedbackCategories/API] Load CitizenGetAllFeedbackCategoriess',
  props<{ citizenGetAllFeedbackCategoriess: CitizenGetAllFeedbackCategories[] }>()
);

export const addCitizenGetAllFeedbackCategories = createAction(
  '[CitizenGetAllFeedbackCategories/API] Add CitizenGetAllFeedbackCategories',
  props<{ citizenGetAllFeedbackCategories: CitizenGetAllFeedbackCategories }>()
);

export const upsertCitizenGetAllFeedbackCategories = createAction(
  '[CitizenGetAllFeedbackCategories/API] Upsert CitizenGetAllFeedbackCategories',
  props<{ citizenGetAllFeedbackCategories: CitizenGetAllFeedbackCategories }>()
);

export const addCitizenGetAllFeedbackCategoriess = createAction(
  '[CitizenGetAllFeedbackCategories/API] Add CitizenGetAllFeedbackCategoriess',
  props<{ citizenGetAllFeedbackCategoriess: CitizenGetAllFeedbackCategories[] }>()
);

export const upsertCitizenGetAllFeedbackCategoriess = createAction(
  '[CitizenGetAllFeedbackCategories/API] Upsert CitizenGetAllFeedbackCategoriess',
  props<{ citizenGetAllFeedbackCategoriess: CitizenGetAllFeedbackCategories[] }>()
);

export const updateCitizenGetAllFeedbackCategories = createAction(
  '[CitizenGetAllFeedbackCategories/API] Update CitizenGetAllFeedbackCategories',
  props<{ citizenGetAllFeedbackCategories: Update<CitizenGetAllFeedbackCategories> }>()
);

export const updateCitizenGetAllFeedbackCategoriess = createAction(
  '[CitizenGetAllFeedbackCategories/API] Update CitizenGetAllFeedbackCategoriess',
  props<{ citizenGetAllFeedbackCategoriess: Update<CitizenGetAllFeedbackCategories>[] }>()
);

export const deleteCitizenGetAllFeedbackCategories = createAction(
  '[CitizenGetAllFeedbackCategories/API] Delete CitizenGetAllFeedbackCategories',
  props<{ id: string }>()
);

export const deleteCitizenGetAllFeedbackCategoriess = createAction(
  '[CitizenGetAllFeedbackCategories/API] Delete CitizenGetAllFeedbackCategoriess',
  props<{ ids: string[] }>()
);

export const clearCitizenGetAllFeedbackCategoriess = createAction(
  '[CitizenGetAllFeedbackCategories/API] Clear CitizenGetAllFeedbackCategoriess'
);


export const citizenGetAllFeedbackCategories = createAction(
  '[CitizenGetAllFeedbackCategories/API] citizen Get All Feedback Categories'
);

